import React from 'react';
import { brandImages } from '../../data/brandImages';

export const KitImage = ({ testId, loading = 'lazy', image = brandImages.kit, alt = image.alt }) => (
  <img
    src={image.src}
    srcSet={image.srcSet}
    sizes={image.sizes}
    alt={alt}
    width={image.width}
    height={image.height}
    className="block w-full h-full object-contain"
    loading={loading}
    decoding="async"
    data-testid={testId}
  />
);